import styled from "styled-components";

export const Input = styled.input``;

export const InputBorder = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
`;

export const Type = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  height: 2rem;
  border-radius: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 1rem;
  flex-basis: 50%;
  max-width: 48%;
  cursor: pointer;
  :hover {
    color: #39b54a;
    border: 1px solid #39b54a;
  }
`;

export const Btn = styled.button`
  border: none;
  width: 10rem;
  padding: 10px;
  border-radius: 0.6rem;
  color: white;
  background-color: #39b54a;
`;
export const EditImageDiv = styled.div`
  display: flex;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  height: fit-content;
  margin: 5px;
  justify-content: space-between;
  align-items: center;
`;
export const RoomInput = styled.input`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
`;
